export class OTA_VehType {
    public vehicleCategory: number;

    static categoryFromEraVehicleType(eraVehType: number): number {
        var category: number = -1;
        switch (eraVehType) {
            case 20: //Passenger
                category = 1;
                break;

            case 21: //Commercial
                category = 5;
                break;
        }

        return category;
    }

    static eraVehicleTypeFromCategory(category: number): number {
        var eraVehType: number = -1;
        switch (category) {
            case 1: //Passenger
                eraVehType = 20;
                break;

            case 5://Commercial
                eraVehType = 21;
                break;
        }

        return eraVehType;
    }
}
